<template>
  <div id="app">
    <div class="top-messages">
      <div id="offline" class="alert alert-danger" style="display: none;">
        <strong>De app is offline.</strong><br>De badges worden doorgestuurd zodra de app terug online is.
      </div>
      <div style="display: none;" id="badge_count" class="alert alert-warning">
        <span>Er zijn nog <strong id="badge_count_number">0</strong> badges niet doorgestuurd.</span>
        <button class="btn btn-sm ml-2 btn-primary" @click="send_badges">Verstuur opnieuw</button>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script type="text/javascript">
  import kiosk from './classes/kiosk'

  export default {
    methods: {
      send_badges: function(){
        // The page sends the queue itself too: legacy rows and browsers
        // without Background Sync depend on it.
        kiosk.flush().catch(() => {});
        if ('serviceWorker' in navigator && 'SyncManager' in window) {
          document.getElementById('badge_count').style.display = 'none';
          this.$helper.startCheckUpdateTimer();
          navigator.serviceWorker.getRegistrations().then(registrations => {
              if (registrations.length > 0) {
                navigator.serviceWorker.ready
                .then(function(sw) {
                  return sw.sync.register('sync-new-badges');
                });
              }
          });
        }
      }
    }
  }
</script>
<style lang="scss">
  @import 'assets/scss/app.scss';
</style>